import SettingsRoutes from './SettingsRoutes'

export default SettingsRoutes